class BaseOption {
    constructor(container) {
        if (!container || !container.length) {
            return;
        } 
        this.container = container;
        this.init();
    }

    init() {
        this.values = this.container.find('.pc-option-value');
        this.bindEvents();
    }

    bindEvents() {
        this.handleValueClick();
    }

    handleValueClick() {
        this.values.on('click', (e) => {
            const value = $(e.currentTarget);
            
            if (value.hasClass('active')) {
                return;
            }

            const index = value.data('index');
            const optionSlug = this.container.data('option-slug');
            
            this.onValueSelect(value, index);

            $(document).trigger('option-changed', {
                element: value,
                value: value.data('value'),
                index: index,
                optionSlug: optionSlug
            });
        });
    }

    onValueSelect(value, index) {
        this.setActiveValue(value);
    }

    setActiveValue(value) {
        console.log(this.container);
        this.container.find('.pc-option-value').removeClass('active');
        value.addClass('active');
    }
} 